import { useSelector } from 'react-redux'
import { b2cSignupSlice } from '../../../../reducers'
import { CREATE_ACCOUNT_STEP } from '../progress-bar'
import {
  Box, Typography
} from '@mui/material'
import clsx from 'clsx'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'

export const useStyles = makeStyles(({ spacing, breakpoints }) => ({
  root: {
    display: 'flex',
    [breakpoints.down('md')]: {
      display: 'none'
    }
  },
  hideMobile: {
    [breakpoints.down('md')]: {
      display: 'flex'
    },
    [breakpoints.up('md')]: {
      display: 'none'
    }
  },
  title: {
    color: '#000000'
  },
  titleDisabled: {
    color: '#707070'
  }

}))

export const PaymentHeading = ({ hideMobile }) => {
  const currentStep = useSelector(b2cSignupSlice.selectors.selectCurrentStep)
  const classes = useStyles()

  return (
    <Box className={clsx(classes.root, hideMobile && classes.hideMobile)} display='flex' alignItems='center' gap={2}>
      {currentStep === CREATE_ACCOUNT_STEP
        ? <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', lineHeight: '20px', width: '58px', height: '58px', justifyContent: 'center', bgcolor: '#DADAFE', color: '#5D5BED', borderRadius: '12px', fontWeight: 'bold' }}>STEP 2</Box>
        : <Box sx={{ display: 'flex', alignItems: 'center', fontSize: '14px', lineHeight: '20px', width: '58px', height: '58px', justifyContent: 'center', bgcolor: '#5D5BED', color: '#fff', borderRadius: '12px', fontWeight: 'bold' }}>STEP 2</Box>}
      <Box>
        <Typography className={clsx(classes.title, currentStep === CREATE_ACCOUNT_STEP && classes.titleDisabled)} variant='h6' fontWeight='bold'>Review & Payment</Typography>
        <Typography variant='caption'>Choose how you would like to be billed.</Typography>
      </Box>
    </Box>
  )
}
